import Axios from "axios";
import { AuthInjector, RedirectUnauthorize } from "./interceptors";
import { AppRoutesUI } from "../../config/appRoutes";

const AxiosAuth = Axios.create();

AuthInjector.Add(AxiosAuth);
RedirectUnauthorize.Add(AxiosAuth, AppRoutesUI.Auth.Login.Path(), () => {
  localStorage.clear();
});

export { AxiosAuth };
